import SoapServices from "@/services/patient/patient-soap.js";
import { some } from "lodash";
const SOAP_LOCKED = 1;
const state = {
    soapDetails: null, //temporary null
    editMode: false,
    editDetails: null,
    isDirty: null,
    countsSoap: null,
    patientStatusActive: true,
    patientStatusInActive: false,
    amendmentsCountsSoap: null,
    documentsCountsSoap: null,
    isLocked: false,
    isSoapEnableBeta: true, // 3476 - now acted as full release - will always redirected to view
    isSoapContentHasDiagnoses: false,
    currentFocusedElementId: null,
    lockedElements: [],
    isAddSnippetOpened: false,
    soapPageInstance: null,
    hasSoapChanges: [], // make it array, to capture multiple field changes // Used to await for all edited input soap successfully updated before reload the soap content
    serverTimestampXMLContent: null,
    initialTimestampXMLContent: null,
    isSocketDisconnectedManually: false
};

const getters = {
    serverTimestampXMLContent: state => {
        return state.serverTimestampXMLContent;
    },
    initialTimestampXMLContent: state => {
        return state.initialTimestampXMLContent;
    },
    soapDetails: state => {
        return state.soapDetails;
    },
    editMode: state => {
        return state.editMode;
    },
    editDetails: state => {
        return state.editDetails;
    },
    isDirty: state => {
        return state.isDirty;
    },
    countsSoap: state => {
        return state.countsSoap;
    },
    patientStatusActive: state => {
        return state.patientStatusActive;
    },
    patientStatusInActive: state => {
        return state.patientStatusInActive;
    },
    amendmentsCountsSoap: state => {
        return state.amendmentsCountsSoap;
    },
    documentsCountsSoap: state => {
        return state.documentsCountsSoap;
    },
    isLocked: state => {
        return state.isLocked;
    },
    isSoapEnableBeta: state => {
        return state.isSoapEnableBeta;
    },
    isSoapContentHasDiagnoses: state => {
        return state.isSoapContentHasDiagnoses;
    },
    currentFocusedElementId: state => {
        return state.currentFocusedElementId;
    },
    lockedElements: state => {
        return state.lockedElements;
    },
    isAddSnippetOpened: state => {
        return state.isAddSnippetOpened;
    },
    soapPageInstance: state => {
        return state.soapPageInstance;
    },
    hasSoapChanges: state => {
        return state.hasSoapChanges;
    },
    isSocketDisconnectedManually: state => {
        return state.isSocketDisconnectedManually;
    }
};
const actions = {
    cancelEdit({ commit }) {
        commit("setEditMode", false);
        commit("setDirty", false);
        commit("setEditDetails", state.soapDetails);
    },
    clearSoapDetails({ commit }) {
        commit("setSoapDetails", null);
    },
    async getSoapDetails({ commit }, soapId) {
        const soap = await SoapServices.getSoapDetails(soapId, true);
        commit("setSoapDetails", soap.resource);
        return soap;
    },
    async getHistoryCountSoap({ commit }, soapId) {
        return SoapServices.getHistoryCountSoap(soapId, true)
            .then(response => {
                if (response.message.code === 200) {
                    commit("setCountsSoap", response.meta.count);
                }
            })
            .catch(error => error.data);
    },
    async checkSoapEnableBeta({ commit }) {
        // VET-3476 - Full release of soap page migration
        let isSoapEnableBeta = true;
        commit("setSoapEnableBeta", isSoapEnableBeta);
        return isSoapEnableBeta;
    },
    async getAmendmentsCountSoap({ commit }, soapId) {
        return SoapServices.getAmendmentsCountSoap(soapId, true)
            .then(response => {
                if (response.code === 200) {
                    commit("setAmendmentsCountsSoap", response.resources.count);
                }
            })
            .catch(error => error.data);
    },
    async getDocumentsCountSoap({ commit }, soapId) {
        return SoapServices.getDocumentsCountSoap(soapId, true)
            .then(response => {
                if (response.code === 200) {
                    commit("setDocumentsCountsSoap", response.response);
                }
            })
            .catch(error => error.data);
    },
    async waitForSoapChanges({ state }, payload) {
        if (state.hasSoapChanges.length === 0) {
            return false;
        }

        if (payload) {
            const { showMessage } = payload;

            // Show message currently saving the soap content
            if (typeof showMessage === "function") {
                showMessage();
            }
        }

        // Wait for hasSoapChanges to become true
        return new Promise(resolve => {
            const unsubscribe = this.watch(
                () => state.hasSoapChanges, // Watch the hasSoapChanges state
                newValue => {
                    if (newValue.length === 0) {
                        // If the state changes to true, resolve the promise
                        unsubscribe(); // Unsubscribe from the watcher
                        resolve(newValue); // Resolve the promise with the new value

                        if (payload) {
                            const { closeMessage } = payload;

                            // Show message currently saving the soap content
                            if (typeof closeMessage === "function") {
                                closeMessage();
                            }
                        }
                    }
                }
            );
        });
    }
};
const mutations = {
    setServerTimestampXMLContent(state, serverTimestampXMLContent) {
        state.serverTimestampXMLContent = parseFloat(serverTimestampXMLContent);
    },
    setInitialTimestampXMLContent(state, initialTimestampXMLContent) {
        state.initialTimestampXMLContent = parseFloat(
            initialTimestampXMLContent
        );
    },
    setIsAddSnippetOpened(state, isAddSnippetOpened) {
        state.isAddSnippetOpened = isAddSnippetOpened;
    },
    setSoapPageInstance(state, soapPageInstance) {
        state.soapPageInstance = soapPageInstance;
    },
    setDirty(state, isDirty) {
        state.isDirty = isDirty;
    },
    setEditMode(state, editMode) {
        state.editMode = editMode;
    },
    setSoapDetails(state, payload) {
        state.soapDetails = payload;
        if (payload) {
            let patientDetails = payload.patient;
            if (patientDetails) {
                state.patientStatusActive = patientDetails
                    ? Number(patientDetails.status) === 1
                    : true;

                state.patientStatusInActive = patientDetails
                    ? Number(patientDetails.status) === 2
                    : false;
            }

            //Based on application/models/orm/TblSoap.php@isLocked
            const currentBusinessId = this.getters["setting"].business_id;
            state.isLocked =
                payload.status === SOAP_LOCKED ||
                payload.business_id !== currentBusinessId;
        }
    },
    setCountsSoap(state, countsSoap) {
        state.countsSoap = countsSoap;
    },
    setSoapEnableBeta(state, isSoapEnableBeta) {
        state.isSoapEnableBeta = isSoapEnableBeta;
    },
    setAmendmentsCountsSoap(state, countsSoap) {
        state.amendmentsCountsSoap = countsSoap;
    },
    setDocumentsCountsSoap(state, countsSoap) {
        state.documentsCountsSoap = countsSoap;
    },
    setIsSoapContentHasDiagnoses(state, isSoapContentHasDiagnoses) {
        state.isSoapContentHasDiagnoses = isSoapContentHasDiagnoses;
    },
    setCurrentFocusedElementId(state, currentFocusedElementId) {
        state.currentFocusedElementId = currentFocusedElementId;
    },
    setLockedElements(state, lockedElements) {
        state.lockedElements = lockedElements;
    },
    updateLockedElements(state, lockedElement) {
        if (!some(state.lockedElements, { id: lockedElement.id })) {
            state.lockedElements.push(lockedElement);
        }
    },
    removeFromLockedElements(state, key) {
        state.lockedElements = state.lockedElements.filter(
            lockedElement => lockedElement.id != key
        );
    },
    pushHasSoapChanges(state) {
        state.hasSoapChanges.push(true);
    },
    removeHasSoapChanges(state) {
        state.hasSoapChanges.splice(0, 1);
    },
    setIsSocketDisconnectedManually(state, isSocketDisconnectedManually) {
        state.isSocketDisconnectedManually = isSocketDisconnectedManually;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
